import { i18n } from '@/locales';
import { validationLimitingValue } from '@/constants';
const { CEO_RESIDENT_REGISTRATION_NUMBER_MAX_LENGTH, CEO_DATE_OF_BIRTH_MAX_LENGTH, } = validationLimitingValue;
const storeLc = 'views.store_management.';
const storeDetailLc = 'views.store_management_detail.';
// 현금영수증
export const cashReceiptsRequiredOptionList = [
    {
        text: i18n.t(`${storeDetailLc}required`),
        value: true,
    },
    {
        text: i18n.t(`${storeDetailLc}selection`),
        value: false,
    },
];
// 완료전 상품대금 정산
export const sendBaromoneyRequiredOptionList = [
    {
        text: i18n.t(`${storeDetailLc}required`),
        value: true,
    },
    {
        text: i18n.t(`${storeDetailLc}selection`),
        value: false,
    },
];
// 접수 제한 금액 부족 시
export const insufficientBaromoneyUnAcceptOptionList = [
    {
        text: i18n.t(`${storeDetailLc}possible_to_order`),
        value: false,
    },
    {
        text: i18n.t(`${storeDetailLc}impossible_to_order`),
        value: true,
    },
];
// 배달대행료 미설정 구간
export const deliveryChargeNonSettingUnAcceptOptionList = [
    {
        text: i18n.t(`${storeDetailLc}possible_to_order`),
        value: false,
    },
    {
        text: i18n.t(`${storeDetailLc}impossible_to_order`),
        value: true,
    },
];
// 기본 할증기능
export const addChargeUseYnOptionList = [
    {
        text: i18n.t('common.use'),
        value: 'Y',
    },
    {
        text: i18n.t('common.no_use'),
        value: 'N',
    },
];
// 픽업소요시간
export const cookingTimeOptionList = [
    {
        text: i18n.t(`${storeDetailLc}not_use`),
        value: 0,
    },
    {
        text: i18n.t('common.minutes_suffix', {
            minutes: 5,
        }),
        value: 5,
    },
    {
        text: i18n.t('common.minutes_suffix', {
            minutes: 10,
        }),
        value: 10,
    },
    {
        text: i18n.t('common.minutes_suffix', {
            minutes: 15,
        }),
        value: 15,
    },
    {
        text: i18n.t('common.minutes_suffix', {
            minutes: 20,
        }),
        value: 20,
    },
    {
        text: i18n.t('common.minutes_suffix', {
            minutes: 25,
        }),
        value: 25,
    },
    {
        text: i18n.t('common.minutes_suffix', {
            minutes: 30,
        }),
        value: 30,
    },
    {
        text: i18n.t('common.minutes_suffix', {
            minutes: 40,
        }),
        value: 40,
    },
    {
        text: i18n.t('common.minutes_suffix', {
            minutes: 50,
        }),
        value: 50,
    },
    {
        text: i18n.t('common.minutes_suffix', {
            minutes: 60,
        }),
        value: 60,
    },
];
// 자동 취소 시간
export const deliveryCancelTimeOptionList = [
    {
        text: i18n.t('common.minutes_suffix', {
            minutes: 0,
        }),
        value: 0,
    },
    {
        text: i18n.t('common.minutes_suffix', {
            minutes: 10,
        }),
        value: 10,
    },
    {
        text: i18n.t('common.minutes_suffix', {
            minutes: 15,
        }),
        value: 15,
    },
    {
        text: i18n.t('common.minutes_suffix', {
            minutes: 20,
        }),
        value: 20,
    },
    {
        text: i18n.t('common.minutes_suffix', {
            minutes: 25,
        }),
        value: 25,
    },
    {
        text: i18n.t('common.minutes_suffix', {
            minutes: 30,
        }),
        value: 30,
    },
    {
        text: i18n.t('common.minutes_suffix', {
            minutes: 40,
        }),
        value: 40,
    },
    {
        text: i18n.t('common.minutes_suffix', {
            minutes: 50,
        }),
        value: 50,
    },
    {
        text: i18n.t('common.minutes_suffix', {
            minutes: 60,
        }),
        value: 60,
    },
];
// 설정할증
export const addChargeApplyYnOptionList = [
    {
        text: i18n.t(`${storeDetailLc}applied`),
        value: true,
    },
    {
        text: i18n.t(`${storeDetailLc}not_applied`),
        value: false,
    },
];
// 관리비 유형
export const deliveryPayFlagDetailOptionList = [
    {
        text: i18n.t(`${storeLc}delivery_pay_flag_code_text[${3}]`),
        value: 'MONTHLY_CHARGE',
    },
    {
        text: i18n.t(`${storeLc}delivery_pay_flag_code_text[${2}]`),
        value: 'MONTHLY_FIXED_AMOUNT',
    },
    {
        text: i18n.t(`${storeLc}delivery_pay_flag_code_text[${1}]`),
        value: 'PER_CASE',
    },
];
// 월 충전 접수불가
export const isMonthlyChargeUnAcceptOptionList = [
    {
        text: i18n.t(`${storeDetailLc}possible_to_order`),
        value: false,
    },
    {
        text: i18n.t(`${storeDetailLc}impossible_to_order`),
        value: true,
    },
];
// 대행료, 관리비 부가세
export const vatRateOptionList = [
    {
        text: i18n.t(`${storeDetailLc}percent`, {
            number: 0,
        }),
        value: 0,
    },
    {
        text: i18n.t(`${storeDetailLc}percent`, {
            number: 10,
        }),
        value: 10,
    },
];
// 납입일
export const deliveryFeeMonthlyDayOptionList = [
    {
        text: i18n.t(`${storeDetailLc}not_use`),
        value: 0,
    },
    {
        text: i18n.t(`${storeDetailLc}regular_pay_specific_day_per_month`, {
            day: 1,
        }),
        value: 1,
    },
    {
        text: i18n.t(`${storeDetailLc}regular_pay_specific_day_per_month`, {
            day: 5,
        }),
        value: 5,
    },
    {
        text: i18n.t(`${storeDetailLc}regular_pay_specific_day_per_month`, {
            day: 10,
        }),
        value: 10,
    },
    {
        text: i18n.t(`${storeDetailLc}regular_pay_specific_day_per_month`, {
            day: 15,
        }),
        value: 15,
    },
    {
        text: i18n.t(`${storeDetailLc}regular_pay_specific_day_per_month`, {
            day: 20,
        }),
        value: 20,
    },
    {
        text: i18n.t(`${storeDetailLc}regular_pay_specific_day_per_month`, {
            day: 25,
        }),
        value: 25,
    },
    {
        text: i18n.t(`${storeDetailLc}end_of_the_month`),
        value: 35,
    },
    {
        text: i18n.t(`${storeDetailLc}every_day`),
        value: 99,
    },
];
export const deliveryFeeMonthlyDayTypeOptionList = [
    {
        text: i18n.t('common.use'),
        value: true,
    },
    {
        text: i18n.t('common.not_use'),
        value: false,
    },
];
export const ceoAdditionalInfoOption = {
    REG_NUMBER: {
        text: i18n.t(`${storeDetailLc}corp_registration_number`),
        value: 'REG_NUMBER',
        placeholder: i18n.t(`${storeLc}registration_number_validation`),
        maxLength: CEO_RESIDENT_REGISTRATION_NUMBER_MAX_LENGTH,
    },
    BIRTH: {
        text: i18n.t(`${storeDetailLc}date_of_birth`),
        value: 'BIRTH',
        placeholder: i18n.t(`${storeLc}birth_validation`),
        maxLength: CEO_DATE_OF_BIRTH_MAX_LENGTH,
    },
};
export const ceoAdditionalInfoOptionList = Object.values(ceoAdditionalInfoOption);
